// removed by extract-text-webpack-plugin
module.exports = {"button":"_2y2jGBVBbLQcrOsNIEpJdP","sml":"_1ge94KdFfqXyRe9hMJTEis","med":"_3Lr6ulJ3YMGIRL9EB77qh9","lrg":"CufErkTU1b4CzMiCC7TD_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Buttons/index.css
// module id = 155
// module chunks = 0